module.exports = {
    title: "Advertisement",
    social_title: 'Social Profile Links',
    crud: {
        create: "Create Advertisement",
        edit: "Edit Advertisement"
    },
    table: {
        name: "Name",
        title: 'Title',
        company: 'Company',
        isVerified: "Verified",
        isActive: 'Active',
        platform: 'Platform',
        SocialLink: 'SocialLink',
    },

    form: {
        name: "Name",
        username: "Username",
        email: 'Email',
        address1: 'Location',
        country: 'Country',
        state: 'State',
        city: 'City',
        mobileNumber: "MobileNumber",
    },
    validation: {
        required: {
            alumnies: 'alumnies is required',
            userId: 'User is required',
            startDate: 'Start Date is required',
            endDate: 'End Date is required',
            repeat: 'Repeat is required',
            buttonAlign: 'Button Align is required',
            buttonActionName: 'Button Action Name is required',
            url: 'URL is required'
        }
    },
}
